document.addEventListener("DOMContentLoaded", function () {

    const button = document.getElementById("giftFinderBtn");

    if (!button) return;

    button.addEventListener("click", function () {

        const occasion = document.getElementById("giftOccasion").value;
        const type = document.getElementById("giftType").value;
        const recipient = document.getElementById("giftRecipient").value;
        const price = document.getElementById("giftPrice").value;

        let redirectURL = "";

        if (occasion !== "") {
            redirectURL = occasion;
        } else if (type !== "") {
            redirectURL = type;
        } else if (recipient !== "") {
            redirectURL = recipient;
        } else if (price !== "") {
            redirectURL = price;
        }

        if (redirectURL !== "") {
            window.location.href = redirectURL;
        } else {
            alert("Please select at least one option.");
        }

    });

});